import {FC, useState, useEffect} from 'react'
import {useFormContext} from 'react-hook-form'
import {InputTextWrapper} from '../../../../../../components/UI/Form/Input'
import {Switch} from '../../../../../../components/UI/Switch'
import {Select} from '../../../../../../components/UI/Select'
import HeaderTitle from '../../../componentes/Form/Header'
import {getLaundryById, getPoint} from '../../../../services'
import {getProfileByUser} from '../../../../../central/services'
import {paginationGuestsService} from '../../../../../hoteleria/features/guests/services'
import {useLavanderia} from '../../../../../../hooks/useLavanderia'
import {TabLavanderiaModel} from '../../../../../../models'
import {LaundryModel, PointModel, SelectModel} from '../../../../model'
import {TITLE_FORM_LAUNDRY_GUEST} from '../../../../util/Constants'
import Swal from 'sweetalert2'
import {ModalSearch} from '../Modal/ModalSearch'
import {useCompany, useCamp, useClient, useSite} from '../../../../../central/hooks'
import useServiceList from '../../../../hooks/useService'
import {clearFields} from '../../../../../../util/functions'
import {initValues} from '../../../../util/values/laundry'
import AditionalForm from '../../../../../../components/UI/Form/aditionalCamp/aditionalCampCentral'
import {useTableMaster} from '../../../../hooks'
import {bookingByGuest} from '../../../../../hoteleria/services/booking.service'
import {useModules} from '../../../../../hoteleria/hooks/useModules'
import {useRooms} from '../../../../../hoteleria/hooks/useRooms'
import {useBed} from '../../../../../hoteleria/hooks/useBed'
const Laundry: FC = () => {
  const {
    register,
    setError,
    formState: {errors},
    control,
    setValue,
    getValues,
    reset,
    watch,
  } = useFormContext()
  const {currentTabItem, changeCurrentTabItem} = useLavanderia()
  const [active, setActive] = useState<boolean>(false)
  const [showModal, setShowModal] = useState<boolean>(false)
  const [hasReservation, setHasReservation] = useState<boolean>(false)
  const [company, setCompany] = useState<SelectModel[]>([])
  const [clients, setClients] = useState<SelectModel[] | any>([])
  const [sites, setSites] = useState<SelectModel[] | any>([])
  const [camps, setCamps] = useState<SelectModel[]>([])
  const [point, setPoint] = useState<SelectModel[]>([])
  const [typeService, setTypeService] = useState<SelectModel[]>([])
  const [moduleOptions, setModuleOptions] = useState([])
  const [roomOptions, setRoomOptions] = useState([])
  const [bedOptions, setBedOptions] = useState([])
  const [finish, setFinish] = useState(false)
  const [responsibleOrder, setResponsibleOrder] = useState<SelectModel[]>([])
  const {typeReception, getTypeReceptionList, getResponsaleOrderList} = useTableMaster()
  const {getServiceMappedData} = useServiceList()
  const {getCompanyFD} = useCompany()
  const {getClientFD} = useClient()
  const {getSiteFD} = useSite()
  const {getCampFD} = useCamp()
  const {getModulesAvailable} = useModules()
  const {getRoomsAvailable} = useRooms()
  const {getBedsAvailable} = useBed()
  const getProfileByUserList = async (id: any) => {
    const response = await getProfileByUser({usuarioId: id}, 1, 100)
    const data = response.data.data
    const filterPerfil = data.filter(
      (item) => item.perfil === 'USUARIO DE LAVANDERÍA' && item.aplicacion === 'Lavandería',
    )
    if (filterPerfil.length === 0) {
      Swal.fire({
        title: 'Huésped, no tiene permiso para usar el servicio de lavandería.',
        text: 'Por favor asignar el permiso en "Central/Usuarios/Permisos"',
        icon: 'warning',
        showCancelButton: false,
        confirmButtonText: 'Aceptar',
        confirmButtonColor: 'var(--kt-primary)',
        cancelButtonText: 'No',
        showLoaderOnConfirm: true,
        allowOutsideClick: () => !Swal.isLoading(),
      }).then(async (result) => {
        // if (result.isConfirmed) {
        setValue('huespedId', '')
        setValue('tipoHuesped', '')
        setValue('empresa', '')
        setValue('telefono', '')
        setValue('email', '')
        setValue('modulo', '')
        setValue('moduloId', '')
        setValue('habitacionId', '')
        setValue('habitacion', '')
        setValue('camaId', '')
        setValue('cama', '')
        Swal.close()
        // }
      })
    }
  }
  const getCompanyList = async () => {
    const response = await getCompanyFD({})
    if (response.length === 1) {
      setValue('companiaId', response[0].value)
      setError('companiaId', {})
      await getClientList(response[0].value as string)
    }

    setCompany(response)
  }
  const getClientList = async (companyId: string) => {
    const response = await getClientFD({companiaId: companyId})
    if (response.length === 1) {
      setValue('clienteId', response[0].value)
      setError('clienteId', {})
      await getSiteList(response[0].value as string)
    }
    setClients(response)
  }
  const getSiteList = async (clientId: string) => {
    const response = await getSiteFD({clienteId: clientId})
    if (response.length === 1) {
      setValue('siteId', response[0].value)
      setError('siteId', {})
      await getCampList(response[0].value as string)
    }
    setSites(response)
  }
  const getCampList = async (siteId: string) => {
    const response = await getCampFD({siteId: siteId})
    if (response.length === 1) {
      setValue('campamentoId', response[0].value)
      setError('campamentoId', {})
      await getPointList()
      await getModulesFn(response[0].value)
      setActive(true)
    }
    setCamps(response)
  }
  const getPointList = async () => {
    let obj: PointModel = {
      isCombo: true,
      companiaId: getValues('companiaId'),
      clienteId: getValues('clienteId'),
      siteId: getValues('siteId'),
      campamentoId: getValues('campamentoId'),
    }
    const response = await getPoint(obj, 1)
    const data = response.data.data
    const mappedSites = data.map((item) => ({
      value: item.id,
      label: item.nombre,
      typeAdmin: item.tipoAdministracion,
      ...item,
    }))
    setPoint(mappedSites)
  }
  const getModulesFn = async (campamentoId?: string) => {
    const data = await getModulesAvailable({
      CampamentoId: campamentoId,
    })
    setModuleOptions(data as any)
    return data
  }

  const getRoomsFn = async (moduloId?: string) => {
    const data = await getRoomsAvailable({
      CampamentoId: watch('campamentoId'),
      ModuloId: moduloId,
    })
    setRoomOptions(data as any)
  }

  const getBedsFn = async (roomId?: string) => {
    const data = await getBedsAvailable({
      CampamentoId: watch('campamentoId'),
      HabitacionId: roomId,
    })
    setBedOptions(data as any)
  }
  const getBedBookings = async (id: any) => {
    try {
      const {data: response} = await bookingByGuest({
        HuespedId: id,
        pageNumber: 1,
        size: 10,
      })
      if (!response.error) {
        let info = response.data[0] || null
        if (info) {
          setValue('modulo', info.Modulo)
          setValue('moduloId', info.ModuloId)
          setValue('habitacionId', info.HabitacionId)
          setValue('habitacion', info.Habitacion)
          setValue('camaId', info.CamaId)
          setValue('cama', info.CodigoCama)
          setHasReservation(true)
        } else {
          setValue('modulo', '')
          setValue('moduloId', '')
          setValue('habitacionId', '')
          setValue('habitacion', '')
          setValue('camaId', '')
          setValue('cama', '')
          setHasReservation(false)
        }
      }
    } catch (error) {}
  }

  const getServiceList = async () => {
    const data = await getServiceMappedData({})
    const filterData = data?.filter((item) => item.tipoOrdenLavadoId === 'ROPA HUÉSPED') || []
    setTypeService(filterData)
  }
  const getResponsaleOrder = async () => {
    try {
      const data = await getResponsaleOrderList()
      const filterData = data?.filter((item) => item.codigo === 'HUÉSPED') || []
      setValue('responsable', filterData[0]?.label || '')
      setValue('responsableId', filterData[0]?.value || '')
      setResponsibleOrder(filterData ?? [])
    } catch (error) {
      console.error('Error al obtener la lista de tipo de documento:', error)
    }
  }
  const getLaundryByIdValues = async () => {
    const response = await getLaundryById(currentTabItem.idToEdit)
    const data = response.data.data
    type LaundryModelKeys = keyof LaundryModel

    for (const fieldName in initValues) {
      if (initValues.hasOwnProperty(fieldName)) {
        if (data.hasOwnProperty(fieldName)) {
          if (data[fieldName as LaundryModelKeys]) {
            if (fieldName === 'clienteId') {
              let valueCompania = data['companiaId']
              let valueClient = data['clienteId']
              getClientList(valueCompania as any)
              setValue('clienteId', valueClient)
            } else if (fieldName === 'siteId') {
              let valueSite = data['siteId']
              let valueClient = data['clienteId']
              getSiteList(valueClient as any)
              setValue('siteId', valueSite)
            } else if (fieldName === 'campamentoId') {
              let valueSite = data['campamentoId']
              let valueClient = data['siteId']
              getCampList(valueClient as any)
              setValue('campamentoId', valueSite)
              getModulesFn(valueSite)
              getPointList()
            } else if (fieldName === 'huespedId') {
              let valueDep = data[fieldName as LaundryModelKeys]
              if (
                valueDep !== null &&
                valueDep !== undefined &&
                valueDep !== '' &&
                typeof valueDep === 'string'
              ) {
                setValue('huespedId', valueDep)
                setError('huespedId', {})
              }
            } else if (fieldName === 'moduloId') {
              let valueDep = data[fieldName as LaundryModelKeys]
              if (
                valueDep !== null &&
                valueDep !== undefined &&
                valueDep !== '' &&
                typeof valueDep === 'string'
              ) {
                setValue('moduloId', valueDep)
                setError('moduloId', {})
                getRoomsFn(valueDep)
              }
            } else if (fieldName === 'habitacionId') {
              let valueDep = data[fieldName as LaundryModelKeys]
              if (
                valueDep !== null &&
                valueDep !== undefined &&
                valueDep !== '' &&
                typeof valueDep === 'string'
              ) {
                setValue('habitacionId', valueDep)
                setError('habitacionId', {})
                getBedsFn(valueDep)
              }
            } else if (fieldName === 'tipoRecepcion') {
              let valueDep = data[fieldName as LaundryModelKeys]
              if (valueDep !== null && valueDep !== undefined && typeof valueDep === 'string') {
                setValue('tipoRecepcion', valueDep)
              }
            } else if (fieldName === 'campoadicionalFec1') {
              let valueDep = data[fieldName as LaundryModelKeys]
              if (valueDep !== null && valueDep !== undefined && typeof valueDep === 'string') {
                const fechaLocal = new Date(valueDep)
                const formattedDate = fechaLocal.toISOString().slice(0, 10)
                setValue(fieldName, formattedDate)
              }
            } else if (fieldName === 'campoadicionalFec2') {
              let valueDep = data[fieldName as LaundryModelKeys]
              if (valueDep !== null && valueDep !== undefined && typeof valueDep === 'string') {
                const fechaLocal = new Date(valueDep)
                const formattedDate = fechaLocal.toISOString().slice(0, 10)
                setValue(fieldName, formattedDate)
              }
            } else {
              setValue(fieldName, data[fieldName as LaundryModelKeys])
            }
          } else {
            setValue(fieldName, '')
          }
          setFinish(true)
        }
      }
    }
  }

  useEffect(() => {
    getCompanyList()
    getServiceList()
    getTypeReceptionList()
    getResponsaleOrder()
    return () => {
      reset()
    }
  }, [])

  useEffect(() => {
    if (typeReception.length > 0) {
      let getValue = typeReception.filter((item) => item.codigo === 'MANUAL')
      setValue('tipoRecepcion', getValue[0].value)
    }
  }, [typeReception])

  useEffect(() => {
    if (currentTabItem.idToEdit) {
      if (finish) {
        if (watch('moduloId') && watch('habitacionId') && watch('camaId')) {
          setHasReservation(true)
        } else {
          setHasReservation(false)
        }
        setFinish(false)
      }
    }
  }, [currentTabItem.idToEdit, finish])

  useEffect(() => {
    if (currentTabItem.idToEdit) {
      getLaundryByIdValues()
    }
  }, [currentTabItem.idToEdit])

  const handleBack = () => {
    const obj: TabLavanderiaModel = {
      ...currentTabItem,
      showPanel: false,
    }
    reset()
    setCompany([])

    changeCurrentTabItem(obj)
  }

  const handleGetClient = (e: any) => {
    let value = e.value
    getClientList(value)
    setValue('companiaId', value)
    setError('companiaId', {})
    clearFields(setValue, setError, {
      clienteId: '',
      siteId: '',
      campamentoId: '',
    })
  }
  const handleGetSite = (e: any) => {
    let value = e.value
    getSiteList(value)
    setValue('clienteId', value)
    setError('clienteId', {})
    clearFields(setValue, setError, {
      siteId: '',
      campamentoId: '',
    })
  }
  const handleGetCamp = (e: any) => {
    let value = e.value
    getCampList(value)
    setValue('siteId', value)
    setError('siteId', {})
    clearFields(setValue, setError, {
      campamentoId: '',
    })
  }

  const handleGetPoint = (e: any) => {
    let value = e.value
    setValue('campamentoId', value)
    setError('campamentoId', {})
    getPointList()
    setActive(true)
    getModulesFn(value)
  }
  const handleGetTypeAdmin = (e: any) => {
    let value = e.value
    setValue('puntoId', value)
    setError('puntoId', {})
    setValue('tipoAdministracion', e.typeAdmin)
    setValue('proveedor', e.proveedor)
  }

  const handleGetTypeReception = (e: any) => {
    let value = e.value
    setValue('tipoRecepcion', value)
    setError('tipoRecepcion', {})
  }

  const getSearchInformation = async (filterUser: any) => {
    setValue('huespedId', filterUser.Id)
    setError('huespedId', {})
    setValue(
      'huesped',
      filterUser.Nombres + ' ' + filterUser.ApellidoPaterno + ' ' + filterUser.ApellidoMaterno,
    )
    setValue('tipoHuesped', filterUser.TipoHuesped_descripcion)
    setValue('empresa', filterUser.Empresa_descripcion)
    setValue('telefono', filterUser.Telefono ?? '')
    setValue('email', filterUser.Email ?? '')
    await getBedBookings(filterUser.Id)
    await getProfileByUserList(filterUser.UsuarioId)
  }
  const handleGetModule = (e: any) => {
    let value = e ? e : ''
    setValue('moduloId', value.value)
    setError('moduloId', {})
    setValue('modulo', value.label)

    getRoomsFn(value.value)
  }
  const handleGetRoom = (e: any) => {
    let value = e ? e : ''
    setValue('habitacionId', value.value)
    setError('habitacionId', {})
    setValue('habitacion', value.label)
    getBedsFn(value.value)
  }
  const handleGetBed = (e: any) => {
    let value = e ? e : ''
    setValue('camaId', value.value)
    setError('camaId', {})
    setValue('cama', value.label)
  }
  let isDisabled = currentTabItem.idToEdit ? true : false
  let isDisabledPanel = currentTabItem.aditionalInformation?.order?.isView || false
  return (
    <div className='sdx_form card p-4'>
      <HeaderTitle
        title={TITLE_FORM_LAUNDRY_GUEST}
        handleBack={handleBack}
        isSearch={true}
        isActive={active}
        handleSearch={() => (active ? setShowModal(true) : null)}
      />
      {isDisabled ? (
        <div className='row'>
          <div className='col-sm-12 col-lg-3'></div>
          <div className='col-sm-12 col-lg-3'>
            <InputTextWrapper
              labelText='Codigo de Bolsa'
              name='bolsaCorrelativo'
              disabled
              readOnly
            />
          </div>
          <div className='col-sm-12 col-lg-3'>
            <InputTextWrapper labelText='Rotulado' name='rotuladoCorrelativo' disabled readOnly />
          </div>
        </div>
      ) : (
        <></>
      )}

      <div className='row'>
        <div className='col-sm-12 col-lg-3'>
          <label className='required'>Compañía:</label>
          <Select
            control={control}
            name='companiaId'
            data={company}
            errors={errors}
            disabled={isDisabled}
            onChangeValue={handleGetClient}
          />
        </div>
        <div className='col-sm-12 col-lg-3'>
          <label className='required'>Cliente:</label>
          <Select
            control={control}
            name='clienteId'
            data={clients}
            errors={errors}
            disabled={isDisabled}
            onChangeValue={handleGetSite}
          />
        </div>
        <div className='col-sm-12 col-lg-3'>
          <label className='required'>Site:</label>
          <Select
            control={control}
            name='siteId'
            data={sites}
            errors={errors}
            disabled={isDisabled}
            onChangeValue={handleGetCamp}
          />
        </div>
        <div className='col-sm-12 col-lg-3'>
          <label className='required'>Campamento:</label>
          <Select
            control={control}
            name='campamentoId'
            data={camps}
            errors={errors}
            disabled={isDisabled}
            onChangeValue={handleGetPoint}
          />
        </div>
        <div className='col-sm-12 col-lg-3'>
          <label className='required'>Tipo de boleta:</label>
          <Select
            control={control}
            name='tipoRecepcion'
            data={typeReception}
            errors={errors}
            onChangeValue={handleGetTypeReception}
          />
        </div>
        {watch('tipoRecepcion') === 'MANUAL' && (
          <div className='col-sm-12 col-lg-3'>
            <InputTextWrapper
              labelText='Nro de boleta'
              name='nroBoleta'
              disabled={isDisabledPanel}
              type='ticketNumber'
              required
            />
          </div>
        )}
        <div className='col-sm-12 col-lg-3'>
          <label className='required'>Punto de Lavandería:</label>
          <Select
            control={control}
            name='puntoId'
            data={point}
            errors={errors}
            onChangeValue={handleGetTypeAdmin}
            disabled={isDisabledPanel}
          />
        </div>
        <div className='col-sm-12 col-lg-3'>
          <InputTextWrapper
            labelText='Tipo de administración'
            name='tipoAdministracion'
            disabled={true}
          />
        </div>
        {watch('tipoAdministracion') === 'EXTERNO' && (
          <div className='col-sm-12 col-lg-3'>
            <InputTextWrapper labelText='Proveedor' name='proveedor' disabled={true} />
          </div>
        )}

        <div className='col-sm-12 col-lg-3'>
          <label className='required'>Tipo de servicio de lavado:</label>
          <Select control={control} name='servicioId' data={typeService} errors={errors} />
        </div>
        <div className='col-sm-12 col-lg-3'>
          <label></label>
          <Select
            control={control}
            name='responsable'
            data={responsibleOrder}
            errors={errors}
            disabled={true}
          />
        </div>

        <div className='col-sm-12 col-lg-3'>
          <InputTextWrapper
            labelText='Nombres del huésped'
            name='huesped'
            disabled={true}
            required
          />
        </div>

        <div className='col-sm-12 col-lg-3'>
          <InputTextWrapper labelText='Tipo Huésped' name='tipoHuesped' disabled={true} />
        </div>
        {hasReservation ? (
          <>
            <div className='col-sm-12 col-lg-3'>
              <InputTextWrapper labelText='Módulo' name='modulo' disabled required />
            </div>
            <div className='col-sm-12 col-lg-3'>
              <InputTextWrapper labelText='Habitación' name='habitacion' disabled required />
            </div>
            <div className='col-sm-12 col-lg-3'>
              <InputTextWrapper labelText='Cama' name='cama' disabled required />
            </div>
          </>
        ) : (
          <>
            <div className='col-sm-12 col-lg-3'>
              <label className='required'>Módulo</label>
              <Select
                control={control}
                name='moduloId'
                data={moduleOptions}
                errors={errors}
                onChangeValue={handleGetModule}
              />
            </div>
            <div className='col-sm-12 col-lg-3'>
              <label className='required'>Habitación</label>
              <Select
                control={control}
                name='habitacionId'
                data={roomOptions}
                errors={errors}
                onChangeValue={handleGetRoom}
              />
            </div>
            <div className='col-sm-12 col-lg-3'>
              <label className='required'>Cama</label>
              <Select
                control={control}
                name='camaId'
                data={bedOptions}
                errors={errors}
                onChangeValue={handleGetBed}
              />
            </div>
          </>
        )}

        <div className='col-sm-12 col-lg-3'>
          <InputTextWrapper labelText='Empresa' name='empresa' disabled={true} />
        </div>
        <div className='col-sm-12 col-lg-3'>
          <InputTextWrapper labelText='Teléfono' name='telefono' disabled={true} />
        </div>
        <div className='col-sm-12 col-lg-3'>
          <InputTextWrapper labelText='Email' name='email' disabled={true} />
        </div>
        <div className='col-sm-12 col-lg-3'>
          <label>Envío de comprobante:</label>
          <Switch
            register={register}
            name='flagEnvioComprobante'
            errors={errors}
            disabled={isDisabledPanel}
          />
        </div>
      </div>
      <hr className='divider' />
      <AditionalForm isDisabled={isDisabledPanel} />
      <ModalSearch
        show={showModal}
        setShow={setShowModal}
        funcSearch={getSearchInformation}
        idCampamento={watch('campamentoId')}
      />
    </div>
  )
}

export default Laundry
